import flatpickr from 'flatpickr';
import { Russian } from 'flatpickr/dist/l10n/ru.js';
import { classInstance } from '@/shared/helpers/helpers';
import { FormInput } from '@/shared/form/form-element/form-input/form-input.ts';

export class FormCalendar {
	private readonly element: HTMLElement;
	private input: HTMLInputElement;
	private formInputInstance: FormInput;
	private button: HTMLElement;
	private calendar: flatpickr;

	constructor(element) {
		if (!element) return;
		this.element = element;
		this.init();
	}

	private handleCalendarOpen = (selectedDates, dateStr, instance): void => {
		instance.setDate(this.input.value);
	};

	private handleCalendarChange = (selectedDates, dateStr): void => {
		this.input.value = dateStr;
		this.input.dispatchEvent(new Event('input'));
	};

	public init = (): void => {
		this.input = this.element.querySelector('.form-input');
		this.formInputInstance = classInstance.get(this.input)?.formElement;
		this.button = this.element.querySelector('.form-element__icon');
		this.calendar = flatpickr(this.button, {
			locale: Russian,
			dateFormat: 'd.m.Y',
			positionElement: this.element,
			position: 'below right',
			onOpen: this.handleCalendarOpen,
			onChange: this.handleCalendarChange,
			disableMobile: true,
		});
		classInstance.set(this.element, { formCalendar: this });
	};

	public destroy = (): void => {
		classInstance.del(this.element, 'formCalendar');
	};
}
